<template>
  <div>
    <div
      v-if="isLargeScreenLayout"
      class="flex flex-1 justify-between mb-4"
    >
      <div>
        <div class="w-20 h-9 mb-2 bg-neutral-200 rounded-sm" />
        <div class="w-24 h-4 bg-neutral-200 rounded-sm" />
      </div>
      <div class="flex flex-col items-end">
        <div class="w-16 h-9 mb-2 bg-neutral-200 rounded-sm" />
        <div class="w-40 h-4 bg-neutral-200 rounded-sm" />
      </div>
    </div>
    <div
      v-else
      class="flex flex-col space-y-2 animate-pulse"
    >
      <div class="w-36 h-7 bg-neutral-200 rounded-sm" />
      <div class="w-20 h-4 bg-neutral-200 rounded-sm" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterSkeletonQuoteTotal',

  props: {
    isLargeScreenLayout: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
